import React from 'react';
import usePipeline from './use-pipeline.js';

function useWillPipe(callback) {
  var pipeline = usePipeline();
  var pipe = React.useRef(callback);
  React.useEffect(function () {
    pipeline.pipe(pipe.current);
    return function () {
      pipeline.removePipe(pipe.current);
    };
  }, []);
}

export default useWillPipe;
//# sourceMappingURL=use-will-pipe.js.map
